<template>
  <b-card>
    <b-row class="mb-2 mx-1 justify-content-start">
      <h4
        class="text-black"
        style="font-size: 24px!important"
      >
        <strong>Skema Ekspedisi</strong>
      </h4>
    </b-row>
    <!-- Navigation Tabs -->
    <div class="px-[16px]">
      <div class="tab-container mb-2">
        <button
          type="button"
          class="tab-btn"
          :class="{ active: activeTab === 'komship' }"
          @click="activeTab = 'komship'"
        >
          Komship
        </button>
        <button
          type="button"
          class="tab-btn"
          :class="{ active: activeTab === 'rajaongkir' }"
          @click="activeTab = 'rajaongkir'"
        >
          Raja Ongkir
        </button>
      </div>
    </div>
    <div>
      <div v-if="activeTab === 'komship'">
        <KomshipExpeditionSchema />
      </div>
      <div v-else>
        <ROExpeditionSchema />
      </div>
    </div>
  </b-card>
</template>

<script>
import KomshipExpeditionSchema from './KomshipExpeditionSchema.vue'
import ROExpeditionSchema from './ROExpeditionSchema.vue'

export default {
  components: { KomshipExpeditionSchema, ROExpeditionSchema },
  data() {
    return {
      activeTab: 'komship',
    }
  },
}
</script>

<style scoped>
/* Tabs */
.tab-container {
  display: inline-flex;
  align-items: center;
  background-color: #f3f4f6;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 3px;
  gap: 3px;
}

.tab-btn {
  border: none;
  background: transparent;
  padding: 6px 16px;
  font-size: 13px;
  font-weight: 500;
  color: #4b5563;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  outline: none;

  &:focus {
    outline: none;
  }

  &.active {
    background-color: #ffffff;
    color: #111827;
    font-weight: 600;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  }

  &:hover:not(.active) {
    color: #111827;
  }
}
</style>
